<template>
    <div class="window-wrapper window-new-mail-no-contacts">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Для создания письма, пожалуйста, заполните данные <router-link :to="{name: 'ClientContacts'}">контактных лиц</router-link></div>
                    <div class="button-block">
                        <button @click="closeWindow" class="button button-dark button-close-window">ОК</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "UserEmptyPhoneWindow",

        methods: {
            closeWindow() {
                $('.window-wrapper').removeClass('window-open');
                $('body').removeClass('blocked');
            }
        }
    }
</script>

<style scoped>

</style>